import { render, staticRenderFns } from "./FieldWorkplaceInfo.vue?vue&type=template&id=51f8e100&scoped=true"
import script from "./FieldWorkplaceInfo.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceInfo.vue?vue&type=script&lang=js"
import style0 from "./FieldWorkplaceInfo.vue?vue&type=style&index=0&id=51f8e100&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8e100",
  null
  
)

export default component.exports